import React from 'react';
import {
    translate,
    Filter,
    List,
    Datagrid,
    TextField,
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    EditButton,
    SimpleShowLayout,
    Show,
} from 'react-admin';
import BoolNumField from '../controls/BoolNumField'
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import {RichTextInput} from 'ra-input-rich-text';
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();



const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const CheckListFilter = props => (
    <Filter {...props}>
        <SearchInput source="name" alwaysOn  placeholder='Checklist Name'/>
        <TextInput source="isactive" lable="Is Active" />
    </Filter>
);

export const QuarantineFilter = props => (
    <Filter {...props}>
        <TextInput source="name" alwaysOn lable="Checklist Name" />
    </Filter>
);

const Heading=({data})=>{
    return (<h3>{data}</h3>)
}



const Contents =({data})=>{

    var contents  = [];
    if(data){
      try{
        contents =JSON.parse(data)
      } catch(e) {
        //console.log(e)
        contents = data;
      };
    }

    return(
      <>
      {contents && contents.map((item, index) =>(
        <tr  key={index}><td style={{fontWeight:'bold'}}>{htmlToReactParser.parse(item['procedure'])}</td><td>{htmlToReactParser.parse(item['referance'])}</td><td>{htmlToReactParser.parse('&nbsp;')}</td><td>{htmlToReactParser.parse('&nbsp;')}</td><td>{htmlToReactParser.parse('&nbsp;')}</td><td>{htmlToReactParser.parse('&nbsp;')}</td></tr>
       )
      )}
     </>
    )
}

const Forms =({data})=>{
    var forms = [];
    if(data){
        try{
            forms = JSON.parse(data);
        } catch(e){
            forms = data;
        }
    }

    var getTable=(_rows, _fields)=>{
        var _tbl = "";
        for(var i=0; i < _rows; i++){
            _tbl=_tbl.concat(`<tr key=${i}>`)
            _fields && _fields.map((item, index) =>(
                _tbl =_tbl.concat('<td>&nbsp;</td>')
                )
            )
            _tbl =_tbl.concat('</tr>')
        }
        return _tbl;
    }

    return(
        <>
        {
            forms && forms.map((fitem, findex)=>(
                <>
                <p></p>
                <p style={{textAlign:'center', fontWeight:'bold'}}>{fitem['form_subheading']}</p>
                <table border="1" cellSpacing="0" style={{width: "100%", textAlign:"center"}}>
                <tbody>
                    <tr key={findex+50}>
                    {
                    fitem['form_fields'].map((item, index) =>(
                        <td><b>{htmlToReactParser.parse(item['field_name'])}</b></td>
                        )
                    )}
                    </tr>
                    {htmlToReactParser.parse(getTable(fitem['num_rows'], fitem['form_fields']))}
                </tbody>
                </table>
                <p></p>
                <p></p>
                 </>
            )

        )}
        </>
    )
}

const PostShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
        <table style={{width:"99%", fontSize: "11px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}>
                                    Training and Education Procedures
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={props.record && props.record.name} /></td>
                            </tr>

                            </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Name:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Center:</td><td style={{width:"30%", border: "1px solid", cellSpacing:"10"}}>&nbsp;</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Initial:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Initial:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Initial:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                            </tr>
                            <Contents data={props.record && props.record.content1} />
                            <tr>
                                <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}><Heading  data={props.record && props.record.sub_heading} /></td>
                            </tr>
                            <Contents data={props.record && props.record.content2} />
                        </tbody>
                    </table>

                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Signature:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Date:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td>Center Manager Signature:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Date:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                <td>&nbsp;Date:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
            </tr>
            <tr>
                <td colSpan="4">
                {
                    (props.record && props.record.form_heading) &&
                    <table style={{width: "100%"}}>
                        <tbody>
                        <tr>
                            <td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="4"><hr /></td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>

                        <tr>
                            <td colSpan="4" style={{textAlign:"center"}}><h2 >TRAINING FORM</h2></td>
                        </tr>
                        <tr>
                            <td colSpan="4" style={{textAlign: "center"}}><Heading  data={props.record && props.record.form_heading} /></td>
                        </tr>
                        <tr>
                            <td >Trainee Name:</td>
                            <td colspan="2" style={{width:"50%", border: "1px solid",cellSpacing:"10", alignSelf:"start" }}>&nbsp;</td>
                            <td  style={{cellSpacing:"10", alignSelf:"start" }}>&nbsp;</td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                            <Forms data={props.record && props.record.forms} />
                            </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td>Trainee Signature:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                            <td>&nbsp;Date:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>Quality  Signature:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                            <td>&nbsp;Date:</td><td style={{width:"30%", border: "1px solid",cellSpacing:"10" }}>&nbsp;</td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="3" style={{fontSize: "7"}}>{props.record && props.record.form_footer}</td>
                            <td>&nbsp;</td>
                        </tr>
                        </tbody>

                    </table>
                }
                </td>
            </tr>

            </tbody>
        </table>
        </SimpleShowLayout>
    </Show>
);



export const CheckList = ({classes,...props }) => (
    <List
        {...props}
        filters={<CheckListFilter />}
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        title={'Checklists Setup'}
        >
        <Datagrid expand={<PostShow />} >
            <TextField source="name" label="Name" />
            <TextField source="roles_desc"label="Role(s)" />
            <BoolNumField  source="isactive" label="Is Active?" />
        </Datagrid>
    </List>
);


export default withStyles(editStyles)(CheckList)